export enum Roles {
  Admin = 'Admin',
  Member = 'Member',
  Manager = 'Manager',
  Operations = 'Operations',
}

export class UserProfile {
  readonly username: string;
  readonly name: string;
  readonly roles: string[];
  readonly isAdmin: boolean;
  readonly isManager: boolean;
  readonly isOperations: boolean;

  constructor(username: string, name: string, roles: string[]) {
    this.username = username;
    this.name = name;
    this.roles = roles || [];

    this.isAdmin = roles.includes(Roles.Admin);
    this.isManager = roles.includes(Roles.Manager);
    this.isOperations = roles.includes(Roles.Operations);
  }
}
